import React, { useState } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Container,
  Alert
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack'

import { suscribeNewsletter } from 'api';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const { enqueueSnackbar } = useSnackbar()

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!email || !termsAccepted) {
      setSubmitStatus('error');
      return;
    }

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setSubmitStatus('invalid');
      return;
    }

    // TODO: Replace with actual newsletter signup logic
    suscribeNewsletter({ email }).then((result) => {

      if (result.message === 'email_already_suscribed') {
        enqueueSnackbar('Sorry, this email is already registered', {
          variant: 'error',
        })
      } else {
        enqueueSnackbar('Thank you for suscribing to our newsletter!', {
          variant: 'success',
        })
      }

      // Reset form
      setEmail('');
      setTermsAccepted(false);
    }).catch(() => {
      setSubmitStatus('error');
    });
  };

  return (
    <Container maxWidth="sm">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              color: 'primary.main'
            }}
          >
            Stay Ahead of the Curve
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              marginBottom: 2,
              color: 'text.secondary'
            }}
          >
            Get the latest updates, exclusive insights, and special offers delivered straight to your inbox.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                label="Email Address"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={submitStatus === 'invalid'}
                helperText={submitStatus === 'invalid' ? 'Please enter a valid email' : ''}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    color="primary"
                  />
                }
                label="I agree to receive newsletters and special offers"
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                endIcon={<SendIcon />}
                disabled={!termsAccepted}
                sx={{
                  padding: '12px',
                  marginTop: 1
                }}
              >
                Subscribe Now
              </Button>

              {submitStatus === 'success' && (
                <Alert severity="success">
                  Thank you for subscribing! You&apos;ll hear from us soon.
                </Alert>
              )}
              {submitStatus === 'error' && (
                <Alert severity="error">
                  Please complete all required fields.
                </Alert>
              )}
            </Box>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default NewsletterSignup;